<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">
        {{ topTitle }}
      </div>
      <div class="title--button"></div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="titleData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
    </my-operate>
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      :checkKey="'purchasesOrderDocId'"
      :keyData="keyData"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      :dialogStatus="1"
      ref="myTable"
    ></myHtml>
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <!-- 发货 -->
    <myOrderAdd
      v-if="htmlDataDialogState.show1"
      :visible="htmlDataDialogState.show1"
      :homeIndex="homeIndex"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderAdd>
    <!-- 详情 -->
    <myOrderDetails
      v-if="htmlDataDialogState.show2"
      :visible="htmlDataDialogState.show2"
      :homeIndex="homeIndex"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderDetails>
  </div>
</template>
<script>
import { selcetSetting, getCurrentTime, _debounce } from "@/utils/myUtils";
import {
  processOutsourcing_list,
  outsourcingDoc_getOutsourcingDoc,
  processOutsourcingReceive_processOutsourcingCanReceiveProduction,
} from "@/api/myController/outsourcing";
export default {
  name: "outsourcingProcesses_order",
  props: {
    titleData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  data() {
    return {
      // 新增、详情、修改
      htmlDataDialogState: {
        show1: false,
        show2: false,
        show3: false,
      },
      routeType: 0,
      routeQuery: {},
      homeIndex: 0,
      // ------------------------------
      type: 1,
      topTitle: "工序委外订单",
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      changeList: [],
      // 操作栏数据
      operationTitleData: [],
      // 排序
      orderParam: {
        asc: false,
        dateAggregateBy: "",
        fieldName: "createTime",
      },
      // 操作栏数据
      titleOperationTitleData: [
        {
          name: "基本信息",
          value: "searchString",
          type: "text",
        },
        { name: "搜索", type: "button" },
      ],
      listLoading: false,
      columnType: "columnAll", // columnIndex序号,columnBox复选框
      // 按钮集合
      tableBtnList: ["详情", "发货"],
      // 表内容
      list: [],
      //
      keyData: ["purchasesOrderDocId"],
      // 表头
      titleList: [
        {
          id: 1,
          name: this.$t("全局搜索码"),
          value: "globalSearchNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 100,
        },
        {
          id: 3,
          name: this.$t("工序委外编号"),
          value: "processOutsourcingDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120,
          color: "#409eff",
          sortable: true,
        },
        {
          id: 4,
          name: this.$t("工序编号"),
          value: "baseProcessNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 5,
          name: this.$t("工序名称"),
          value: "baseProcessName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 6,
          name: this.$t("委外商名称"),
          value: "baseSupplierName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("委外数量"),
          value: "baseOutsourcingQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 75,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("开始时间"),
          value: "startTime",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("结束时间"),
          value: "endTime",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("收货时间"),
          value: "receivingTime",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("出货时间"),
          value: "deliveryTime",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("已收货数量"),
          value: "valueFinishedQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 90,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("未收货数量"),
          value: "valueUnfinishedQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 90,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("已发料数量"),
          value: "valueRequisitionQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 90,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("未发料数量"),
          value: "valueUnrequisitionQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 90,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("委外单价"),
          value: "baseMaterialUnitprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 75,
          sortable: true,
        },
        {
          id: 0,
          name: this.$t("委外总价"),
          value: "baseMaterialTotalprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 75,
          sortable: true,
        },
        {
          id: 7,
          name: this.$t("委外单状态"),
          value: "statusDoc",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: this.$t("进行中"),
              value: 0,
              color: "white",
              backGroundColor: "rgb(102, 102, 102)",
            },
            {
              label: this.$t("已完成"),
              value: 1,
              color: "white",
              backGroundColor: "rgb(79,129,246)",
            },
            {
              label: this.$t("已结束"),
              value: 2,
              color: "white",
              backGroundColor: "rgb(106, 168, 79)",
            },
          ],
          canEdit: false,
          width: 100,
        },
        {
          id: 7,
          name: this.$t("发料状态"),
          value: "statusRequisition",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: this.$t("未发料"),
              value: 0,
              color: "white",
              backGroundColor: "rgb(102, 102, 102)",
            },
            {
              label: this.$t("部分发料"),
              value: 1,
              color: "white",
              backGroundColor: "rgb(79,129,246)",
            },
            {
              label: this.$t("完全发料"),
              value: 2,
              color: "white",
              backGroundColor: "rgb(106, 168, 79)",
            },
            {
              label: this.$t("超量发料"),
              value: 3,
              color: "white",
              backGroundColor: "rgb(106, 168, 79)",
            },
          ],
          canEdit: false,
          width: 100,
        },
        {
          id: 14,
          name: this.$t("审核状态"),
          value: "statusCheck",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: this.$t("已审核"),
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: this.$t("未审核"),
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: false,
          width: 100,
        },
        {
          id: 29,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          width: 180,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    $t(val) {
      return val;
    },
    getList() {
      this.listLoading = true;
      processOutsourcing_list({
        orderParam: [this.orderParam],
        processOutsourcingDtoFilter: this.titleData,
        pageParam: this.listQuery,
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            try {
              item.specifications = JSON.parse(item.baseMaterialSpecDesc);
            } catch (error) {
              item.specifications = [];
            }
            try {
              if (item.baseBomVersion) {
                item.baseBomVersionV2 = "V" + item.baseBomVersion;
              } else {
                item.baseBomVersionV2 = "---";
              }
            } catch (error) {}
          });
          this.list = res.data.data.dataList;
          this.listQuery.total = res.data.data.totalCount;
        } else {
          this.list = [];
        }
        this.listLoading = false;
        this.$refs.myOperate?.dragSortShow();
      });
    },
    async titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();

        default:
          break;
      }
    },
    // 操作栏点击事件
    operationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();
          break;
        default:
          break;
      }
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        case "详情":
          this.routeQuery = row;
          this.homeIndex = 127;
          this.htmlDataDialogState.show2 = true;
          break;
        case "退料":
          outsourcingDoc_getOutsourcingDoc({
            outsourcingDocId: row.outsourcingDocId,
          }).then((res) => {
            if (res.data.data.outsourcingDocMaterialList.length > 0) {
              this.routeQuery = res.data.data;
              this.routeType = 1;
              this.homeIndex = 49;
              this.htmlDataDialogState.show1 = true;
            } else {
              this.$message.error("暂无可退物料！");
            }
          });

          break;
        case "发货":
          if (row.statusCheck == 0) {
            this.$message.info(this.$t("未审核"));
            return;
          }
          processOutsourcingReceive_processOutsourcingCanReceiveProduction({
            processOutsourcingDocId: row.processOutsourcingDocId,
          }).then((res) => {
            if (res.data.data) {
              try {
                res.data.data.specifications = JSON.parse(
                  res.data.data.baseSpecgroupDesc
                );
              } catch (error) {
                res.data.data.specifications = [];
              }
              res.data.data.batchNumberJson = [];
              res.data.data.batchNumberJsonName = null;
              res.data.data.globalSearchNumber = row.globalSearchNumber;
              res.data.data.baseInwarehouseTime = getCurrentTime();
              res.data.data.baseProcessOutsourcingDocId = row.processOutsourcingDocId;
              res.data.data.baseOutsourcingFinishedQuantity = 1;
              res.data.data.processOutsourcingReceiveDocId = null;
              res.data.data.baseProcessOutsourcingDocNumber =
                row.processOutsourcingDocNumber;
              this.routeQuery = {
                data: row,
                list: res.data.data,
              };
              this.routeType = 1;
              this.homeIndex = 172;
              this.htmlDataDialogState.show1 = true;
            } else {
              this.$message.error(this.$t("暂无可收货"));
            }
          });
          break;
        default:
          break;
      }
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        case "processOutsourcingDocNumber":
          this.routeQuery = row;
          this.homeIndex = 127;
          this.htmlDataDialogState.show2 = true;
          break;

        default:
          break;
      }
    },
    changeType() {
      this.type = command;
    },
    // 多选
    selectChangeEvent(val) {
      this.changeList = val.records;
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records;
    },
    htmlDataDialogClose(state, data) {
      this.htmlDataDialogState.show1 = false;
      this.htmlDataDialogState.show2 = false;
      this.htmlDataDialogState.show3 = false;
      this.getList();
    },
    // 列宽拖动事件
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    // 开始拖拽事件
    onStart(titleList) {},
    // 拖拽结束事件
    onEnd(titleList) {
      this.titleList = titleList;
    },
    // 复选框事件
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    // 固定方向事件
    widthClick(titleList) {
      this.titleList = titleList;
    },
    // 重置
    async resetClick(titleList) {
      this.titleList = titleList;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
      justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.spanText {
  color: #1476c3;
  font-size: 14px;
}

.operations {
  float: left;
  width: 200px;
  padding-top: 6px;
}

/*  修改页面样式 */

.title--font {
  text-align: left;
  padding: 10px 0;
}
::v-deep .operation {
  margin-bottom: 10px;
}
::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}
::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}
::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}
::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
.title--button {
  right: 0;
  margin-top: 0.7%;
}
</style>
